import Table from '../../../app-components/table/Table';
let data=[]
export default Table({data});
